const stickyMenu = {
    variable_1: '#1',
    init() {
        this.events();
    },
    events() {
        /**
         * Execute events
         */
        var self = this;
        this.executeSticky();
        window.onscroll = function() {
            self.executeSticky();
        };
    },    
    executeSticky() {
        var navbar = jQuery('.listing-search');
        var position = jQuery(navbar).position();
        var top = position.top - document.documentElement.scrollTop;
        if (top < 40) {
            jQuery(navbar).addClass('sticky-search');
        } else {
            jQuery(navbar).removeClass('sticky-search');
        }
    },
};
jQuery(() => {
    stickyMenu.init();
});